<!--begin::Heading-->
<div class="text-center pb-3">
  <img src="./assets/media/logos/free_float_platform_logo.png" alt="FF Logo" height="45" />
</div>
<div class="mb-10">
  <h3>Create an Account</h3>
  <p class="mb-4 text-body-tertiary">Already have an account? <a
    routerLink="/auth/login"
    class="link-primary fw-bolder"
    [style.margin-left]="'5px'"
  >Sign in</a
  ></p>
</div>
<!--end::Heading-->
<form
  class="form w-100 fv-plugins-bootstrap5 fv-plugins-framework"
  novalidate="novalidate"
  id="kt_login_signup_form"
  [formGroup]="registrationForm"
  (ngSubmit)="submit()">


  <!-- begin::Alert error-->
  <ng-container *ngIf="hasError">
    <div class="mb-lg-15 alert alert-danger">
      <div class="alert-text font-weight-bold">
        The registration details are incorrect
      </div>
    </div>
  </ng-container>
  <!-- end::Alert error-->

  <!--begin::Form group-->
  <div class="fv-row mb-7">
    <input
      class="form-control form-control-lg form-control-solid"
      type="text"
      name="name"
      formControlName="name"
      placeholder="Full name"
      [ngClass]="{
        'is-invalid': registrationForm.controls['name'].invalid && registrationForm.controls['name'].dirty,
        'is-valid': registrationForm.controls['name'].valid
      }" />
    <ng-container
      [ngTemplateOutlet]="formError"
      [ngTemplateOutletContext]="{
        validation: 'required',
        message: 'Fullname is required',
        control: registrationForm.controls['name']
      }"></ng-container>
    <ng-container
      [ngTemplateOutlet]="formError"
      [ngTemplateOutletContext]="{
        validation: 'minlength',
        message: 'Fullname should have at least 3 symbols',
        control: registrationForm.controls['name']
      }"></ng-container>
    <ng-container
      [ngTemplateOutlet]="formError"
      [ngTemplateOutletContext]="{
        validation: 'maxLength',
        message: 'Fullname should have maximum 100 symbols',
        control: registrationForm.controls['name']
      }"></ng-container>
  </div>
  <!--end::Form group-->

  <!--begin::Form group-->
  <div class="fv-row mb-7">
    <input
      class="form-control form-control-lg form-control-solid mt-4"
      type="email"
      placeholder="Email"
      name="email"
      formControlName="email"
      [ngClass]="{
        'is-invalid': registrationForm.controls['email'].invalid && registrationForm.controls['email'].dirty,
        'is-valid': registrationForm.controls['email'].valid
      }" />
    <ng-container
      [ngTemplateOutlet]="formError"
      [ngTemplateOutletContext]="{
        validation: 'required',
        message: 'Email is required',
        control: registrationForm.controls['email']
      }"></ng-container>
    <ng-container
      [ngTemplateOutlet]="formError"
      [ngTemplateOutletContext]="{
        validation: 'email',
        message: 'Email is invalid',
        control: registrationForm.controls['email']
      }"></ng-container>
    <ng-container
      [ngTemplateOutlet]="formError"
      [ngTemplateOutletContext]="{
        validation: 'minlength',
        message: 'Email should have at least 3 symbols',
        control: registrationForm.controls['email']
      }"></ng-container>
    <ng-container
      [ngTemplateOutlet]="formError"
      [ngTemplateOutletContext]="{
        validation: 'maxLength',
        message: 'Email should have maximum 360 symbols',
        control: registrationForm.controls['email']
      }"></ng-container>
  </div>
  <!--end::Form group-->

  <!--begin::Form group-->
  <div class="mb-10 fv-row">
    <input
      class="form-control form-control-lg form-control-solid  mt-4"
      type="password"
      placeholder="Password"
      name="password"
      formControlName="password"
      [ngClass]="{
        'is-invalid': registrationForm.controls['password'].invalid && registrationForm.controls['password'].dirty,
        'is-valid': registrationForm.controls['password'].valid
      }" />
    <ng-container
      [ngTemplateOutlet]="formError"
      [ngTemplateOutletContext]="{
        validation: 'required',
        message: 'Password is required',
        control: registrationForm.controls['password']
      }"></ng-container>
    <ng-container
      [ngTemplateOutlet]="formError"
      [ngTemplateOutletContext]="{
        validation: 'minlength',
        message: 'Password should have at least 3 symbols',
        control: registrationForm.controls['password']
      }"></ng-container>
    <ng-container
      [ngTemplateOutlet]="formError"
      [ngTemplateOutletContext]="{
        validation: 'maxLength',
        message: 'Password should have maximum 100 symbols',
        control: registrationForm.controls['password']
      }"></ng-container>
  </div>
  <!--end::Form group-->

  <!--begin::Form group-->
  <div class="fv-row">
    <input
      class="form-control form-control-lg form-control-solid mt-4"
      type="password"
      placeholder="Confirm password"
      name="password_confirmation"
      formControlName="password_confirmation"
      [ngClass]="{
        'is-invalid': registrationForm.controls['password_confirmation'].invalid && registrationForm.controls['password_confirmation'].dirty,
        'is-valid': registrationForm.controls['password_confirmation'].valid
      }" />
    <ng-container
      [ngTemplateOutlet]="formError"
      [ngTemplateOutletContext]="{
        validation: 'required',
        message: 'Confirm Password is required',
        control: registrationForm.controls['password_confirmation']
      }"></ng-container>
    <ng-container
      [ngTemplateOutlet]="formError"
      [ngTemplateOutletContext]="{
        validation: 'minlength',
        message: 'Confirm Password should have at least 3 symbols',
        control: registrationForm.controls['password_confirmation']
      }"></ng-container>
    <ng-container
      [ngTemplateOutlet]="formError"
      [ngTemplateOutletContext]="{
        validation: 'maxLength',
        message: 'Confirm Password should have maximum 100 symbols',
        control: registrationForm.controls['password_confirmation']
      }"></ng-container>
    <ng-container
      *ngIf="
        registrationForm.controls['password_confirmation'].errors &&
        registrationForm.controls['password_confirmation'].errors['ConfirmPassword']
      ">
      <div class="fv-plugins-message-container">
        <div class="fv-help-block">
          'Passsword' and 'Confirm Password' didn't match.
        </div>
      </div>
    </ng-container>
  </div>
  <!--end::Form group-->

  <!--begin::Form group-->
  <div class="fv-row mb-4 mt-4">
    <div class="form-check form-check-custom form-check-solid">
      <input
        id="kt_login_toc_agree"
        type="checkbox"
        formControlName="agree"
        name="agree"
        class="form-check-input" />

      <label
        for="kt_login_toc_agree"
        class="form-check-label fw-bold text-gray-700 fs-6">
        I agree to the&nbsp;<a
          href="https://www.freefloat.llc/terms-and-conditions"
          target="_blank"
          class="ms-1 link-primary"
          >terms and conditions</a
        >.
      </label>
    </div>
  </div>
  <!--end::Form group-->

  <!--begin::Form group-->
  <div class="text-center">
    <button
      type="submit"
      id="kt_sign_up_submit"
      [disabled]="
        registrationForm.invalid || !registrationForm.controls['agree'].value
      "
      class="btn btn-lg btn-primary w-100 mb-5">
      <ng-container *ngIf="(isLoading$ | async) === false">
        <span class="indicator-label">Sign up</span>
      </ng-container>
      <ng-container *ngIf="isLoading$ | async">
        <span class="indicator-progress" [style.display]="'block'">
          Please wait...
          <span
            class="spinner-border spinner-border-sm align-middle ms-2"></span>
        </span>
      </ng-container>
    </button>
  </div>
  <!--end::Form group-->
</form>

<ng-template
  #formError
  let-control="control"
  let-message="message"
  let-validation="validation">
  <ng-container
    *ngIf="control.hasError(validation) && (control.dirty || control.touched)">
    <div class="fv-plugins-message-container">
      <div class="fv-help-block">
        <span role="alert">
          {{ message }}
        </span>
      </div>
    </div>
  </ng-container>
</ng-template>
